import { Check, ArrowRight } from "lucide-react";
import { Reveal } from "../motion/Reveal";
import { CountdownTimer } from "./CountdownTimer";
import { SpotsRemaining } from "./SpotsRemaining";
import { CHECKOUT_URL, pricingFeatures, PRICING_TEXTURE_IMG } from "../../data/academyData";

export const Pricing = () => (
  <section id="pricing" data-testid="pricing-section" className="relative py-20 md:py-32 overflow-hidden border-t border-white/[0.06]">
    <div className="absolute inset-0 -z-10">
      <img src={PRICING_TEXTURE_IMG} alt="" className="w-full h-full object-cover opacity-20" />
      <div className="absolute inset-0 bg-gradient-to-b from-black via-black/85 to-black" />
    </div>
    <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-rose-400 font-semibold mb-4 text-center">Founding Member Offer</p>
        <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-semibold text-white text-center leading-tight">This Price Closes After 100 Members.</h2>
      </Reveal>

      <Reveal delay={0.1}>
        <div className="mt-12 rounded-3xl bg-white/[0.04] border border-rose-500/30 p-8 sm:p-10 shadow-[0_0_60px_rgba(229,9,20,0.15)] backdrop-blur-xl">
          <div className="flex items-baseline justify-center gap-3">
            <span className="text-2xl text-zinc-500 line-through">₹9,999</span>
            <span className="font-heading text-5xl sm:text-6xl font-bold text-white">₹999</span>
          </div>
          <p className="text-center text-rose-400 text-sm font-mono mt-2 uppercase tracking-wider">One payment. Lifetime access.</p>

          <div className="mt-8 flex justify-center"><CountdownTimer /></div>
          <div className="mt-6 flex justify-center"><SpotsRemaining /></div>

          <ul className="mt-8 space-y-3">
            {pricingFeatures.map((f) => (
              <li key={f} className="flex items-start gap-3 text-zinc-200">
                <Check size={18} className="text-emerald-400 mt-0.5 shrink-0" /> {f}
              </li>
            ))}
          </ul>

          <a
            href={CHECKOUT_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="pricing-cta-button"
            className="mt-8 w-full inline-flex items-center justify-center gap-2 rounded-full bg-rose-600 hover:bg-rose-500 text-white font-semibold text-lg px-8 py-4 transition-all hover:scale-[1.02] shadow-[0_0_30px_rgba(229,9,20,0.45)]"
          >
            Yes — I Want To Join AX Academy <ArrowRight size={20} />
          </a>
          <p className="mt-4 text-center text-xs text-zinc-500">🔒 Safe & Secure Payment · 📩 Instant Access · 🛡️ 7-Day Guarantee</p>
        </div>
      </Reveal>
    </div>
  </section>
);
